import { render, staticRenderFns } from "./LicenseRequirements.vue?vue&type=template&id=625edc30&scoped=true&"
import script from "./LicenseRequirements.vue?vue&type=script&lang=js&"
export * from "./LicenseRequirements.vue?vue&type=script&lang=js&"
import style0 from "./LicenseRequirements.vue?vue&type=style&index=0&id=625edc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625edc30",
  null
  
)

export default component.exports